__turbopack_context__.v({
  "center": "_9X151a_center",
  "checkbox": "_9X151a_checkbox",
  "dataPrivacy": "_9X151a_dataPrivacy",
  "sentence": "_9X151a_sentence",
});
